import { render, staticRenderFns } from "./MoleculeEditionAssetContentsModalCreateVersion.vue?vue&type=template&id=1057dc56&"
import script from "./MoleculeEditionAssetContentsModalCreateVersion.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAssetContentsModalCreateVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports